import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import InstallApp from "@/pages/InstallApp";

export const Route = createFileRoute("/install")({
  head: () => seoHead("/install"),
  component: InstallApp,
});
